import { render, staticRenderFns } from "./EditModeSaveMenu.vue?vue&type=template&id=5d78500b&scoped=true"
import script from "./EditModeSaveMenu.vue?vue&type=script&lang=js"
export * from "./EditModeSaveMenu.vue?vue&type=script&lang=js"
import style0 from "./EditModeSaveMenu.vue?vue&type=style&index=0&id=5d78500b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d78500b",
  null
  
)

export default component.exports